/* The Cipzo trade application — PACKET-03E / D8.
 *
 * ⛔ THIS FORM IS THE ONLY WAY SOME PROSPECTS EVER REACH THE BUSINESS, so every failure it can
 *    produce has to be visible. The form it will eventually replace accepted a PDF and silently
 *    discarded it; the one before that put registrations in a marketing list nobody reconciled.
 *    Nothing here may fail quietly.
 *
 * ⛔ AND IT MUST WORK LOGGED OUT. Verified from a clean browser: /trade/apply answers identically
 *    signed in and signed out, because a prospect applying does not have an account yet. Nothing in
 *    this file may depend on window.LFY_TRADE, which only exists for approved trade customers.
 */
(function () {
  var root = document.querySelector("[data-lfy-apply]");
  if (!root) return;

  var form = root.querySelector("[data-apply-form]");
  var statusEl = root.querySelector("[data-apply-status]");
  var doneEl = root.querySelector("[data-apply-done]");
  var submitBtn = root.querySelector("[data-apply-submit]");
  var companyEl = root.querySelector("[data-apply-company]");
  if (!form || !submitBtn) return;

  /* ⛔ ARM THE BUTTON. It ships `disabled` so that a click landing before this script ran cannot
   * silently do nothing — see the note in lfy-trade-apply.liquid. Everything this handler needs is
   * resolved by now (form, submitBtn), so this is the first moment a press can actually be served.
   * ⚠️ Enable it HERE, not at the end of the file: a throw in any later setup would otherwise leave
   * the button permanently dead, which trades a silent no-op for a silent lockout. */
  submitBtn.disabled = false;
  var armingNote = root.querySelector("[data-apply-arming]");
  if (armingNote) armingNote.hidden = true;

  function say(text, tone) {
    if (!statusEl) return;
    statusEl.textContent = text || "";
    statusEl.className = "lfy-apply__status" + (tone ? " is-" + tone : "");
  }

  /* ⛔ REASON FIRST, STATUS SECOND — the same rule as the rest of this surface, and for the same
   * reason: 429 carries two different refusals and one of them is not about this applicant at all.
   *
   * messageFor lives in lfy-trade-project.js, which is only loaded for APPROVED trade customers —
   * exactly the people who will never see this form. So the sentences are here, deliberately
   * duplicated rather than shared: a prospect must get a real message, and reaching for a function
   * that is undefined for them would produce the silent failure this whole form exists to avoid. */
  function messageFor(status, reason) {
    if (reason === "missing_company") {
      return { tone: "warn", text: "Please enter your business name so we can set the account up." };
    }
    if (reason === "already_open") {
      return { tone: "ok", text: "You already have an application with us — we'll be in touch. No need to send another." };
    }
    if (reason === "rate_limited_applicant") {
      return { tone: "warn", text: "You've just sent this to us — give us a moment before trying again." };
    }
    /* ⛔ NOT "you have tried too many times". Every signed-out applicant shares one bucket
     * server-side, so this refusal is usually about someone else's traffic entirely. Blaming a
     * person who has typed their details once would be false, and telling them to keep retrying
     * would send them at a cap that is not going to move for them. */
    if (reason === "rate_limited_shop" || reason === "rate_limited") {
      return { tone: "warn", text: "We can't take another application just now. Please try again shortly, or email ashfield@lightsforyou.com.au and we'll set you up." };
    }
    /* ⛔ THE SERVER WILL REFUSE RATHER THAN TRUNCATE, and the caps become owner-editable config.
     * Both change what these numbers mean here: they are a client-side COURTESY, not the contract.
     * If the founder raises the message cap in the console, the server is right and my warning is
     * stale — so the refusal has to be handled properly rather than treated as unreachable just
     * because maxlength currently makes it hard to provoke. */
    if (reason === "application_message_too_long") {
      return { tone: "warn", text: "That message is longer than we can accept. Please shorten it, or email the detail to ashfield@lightsforyou.com.au." };
    }
    if (reason === "trade_type_too_long") {
      return { tone: "warn", text: "That trade type is too long — a few words is plenty, such as Electrical contractor." };
    }
    if (reason === "write_error" || reason === "invalid_limits") {
      return { tone: "err", text: "Your application couldn't be saved. Please email ashfield@lightsforyou.com.au and we'll do it by hand." };
    }
    /* ⛔ duplicate_abn — MEASURED ON THE LIVE FORM 2026-09-20, not anticipated. A real submission
     * (founder-authorised, support@cipzo.com) got:
     *     409 {"reason":"duplicate_abn",
     *          "detail":"This ABN is already registered — contact us if you're a separate branch or site."}
     * and this file mapped EIGHTEEN reasons, none of them this one. So the applicant was shown the
     * bottom fall-through — "That couldn't be sent. Please email ashfield@…" — which is the exact
     * defect the comment below already warns about, one reason later: the server named a specific,
     * ACTIONABLE cause and the theme threw it away for a dead end.
     *
     * 🔑 The distinction matters to a real person. `already_open` means "you have applied, sit
     * tight". THIS means "your BUSINESS is already on the system" — which for a second branch or
     * site is not a refusal at all, it is a different conversation. Telling them to email support
     * with no reason makes them think the form is broken.
     *
     * ⚠️ Same voice as its neighbours: second person, says what to do next, no enum leaks. The
     * server's own detail is close enough to keep its meaning, reworded to the form's voice. */
    if (reason === "duplicate_abn") {
      return { tone: "warn", text: "That ABN is already registered with us. If this is a separate branch or site, email ashfield@lightsforyou.com.au and we'll set it up." };
    }
    /* ⛔ THE NINE FIELD REFUSALS THE SERVER CAN NAME. Added 2026-09-11 against the merged intake
     * lane (Cipzo integration-2026-09-11). Before this, every one of them fell through to the
     * generic "email us" line at the bottom: a trader who mistyped an ABN was told to send an
     * email rather than to check the eleven digits in front of them.
     *
     * ⚠️ REACHABLE ONLY WHILE THE TWO LAYERS DISAGREE — which is exactly why they are here. The
     * RULES array below refuses all six fields client-side, so in the normal case the server never
     * sees a bad one. These fire when that assumption breaks: a direct POST, a stale cached script,
     * autofill that dodges the listener, or the day one layer's regex is widened and the other is
     * not. Treating them as unreachable is the same convenience-not-enforcement mistake that let
     * the original single-field server accept an application nobody could reply to.
     *
     * 🔑 THE INVALID_* SENTENCES ARE THE SAME STRINGS AS `RULES` BELOW, DELIBERATELY. The server's
     * `detail` for invalid_abn / invalid_email / invalid_phone is already character-for-character
     * what this form says inline, so a refusal cannot contradict the hint the field just gave.
     * ⛔ The MISSING_* sentences are NOT lifted from the server. Its details read "An ABN is
     * required." — correct, and the wrong voice for a person looking at the field. The form asks
     * in the second person everywhere else and keeps doing so here. */
    if (reason === "missing_abn") {
      return { tone: "warn", text: "Enter your ABN." };
    }
    if (reason === "invalid_abn") {
      return { tone: "warn", text: "An ABN is 11 digits — please check it." };
    }
    if (reason === "missing_trade_type") {
      return { tone: "warn", text: "Choose or type your trade." };
    }
    if (reason === "missing_contact_name") {
      return { tone: "warn", text: "Enter your name so we know who to contact." };
    }
    if (reason === "missing_email") {
      return { tone: "warn", text: "Enter an email address we can reach you on." };
    }
    if (reason === "invalid_email") {
      return { tone: "warn", text: "That doesn't look like an email address — please check it." };
    }
    if (reason === "missing_phone") {
      return { tone: "warn", text: "Enter a phone number we can call you on." };
    }
    if (reason === "invalid_phone") {
      return { tone: "warn", text: "Use digits only for the phone number — for example 0412 345 678." };
    }
    /* The cap is the server's and it is owner-editable, so the number is not repeated here — a
     * figure that goes stale in the console would be worse than no figure. Same argument as the
     * message cap above. */
    if (reason === "company_name_too_long") {
      return { tone: "warn", text: "That business name is longer than we can accept — please shorten it." };
    }
    if (status === 200 || status === 201) {
      return { tone: "ok", text: "Application received." };
    }
    /* Anything unnamed still gets a route out. An applicant cannot act on a status code, but they
     * can send an email, and that is better than a dead end. */
    return { tone: "err", text: "That couldn't be sent. Please email ashfield@lightsforyou.com.au and we'll set your account up." };
  }

  /* ⛔ THESE NUMBERS ARE A COURTESY, NOT THE CONTRACT. They mirror the server's caps today, but
   * those are becoming owner-editable config — so this list can go stale in either direction, and
   * only one direction is safe. Too HIGH is fine: the server refuses with a named reason and the
   * applicant is told. Too LOW silently denies them room they are allowed, which is the failure
   * this whole file exists to avoid. Asked for the caps on the wire; until then these are kept in
   * step by hand and the server is always the authority.
   *
   * Blank fields are OMITTED rather than sent as
   * empty strings — the server normalises "" to null anyway, but sending one would claim the
   * applicant chose to leave it blank rather than simply not filling it in. */
  var CAPS = { companyName: 200, abn: 20, contactName: 200, contactEmail: 200, contactPhone: 40, tradeType: 120, message: 2000 };
  function collect() {
    var body = {};
    Object.keys(CAPS).forEach(function (k) {
      var el = form.querySelector('[name="' + k + '"]');
      if (!el) return;
      var v = String(el.value || "").trim().slice(0, CAPS[k]);
      if (v) body[k] = v;
    });
    return body;
  }

  /* ⛔ maxlength SILENTLY TRUNCATES A PASTE, so capping the input moved the silent data loss
   * rather than removing it. The server slices at the same limits without refusing, which the app
   * lane found and told me — so these caps are currently the ONLY thing between a long answer and
   * a quietly clipped one. That makes them load-bearing, and a load-bearing limit the applicant
   * cannot see is the same defect one layer up.
   *
   * So the limit becomes visible as it is approached, and says plainly what happens at it. Someone
   * pasting three paragraphs into a 2000-character box now finds out at the moment it happens,
   * instead of discovering later that we only ever read half of what they wrote. */
  var updaters = [];
  function wireCounters() {
    root.querySelectorAll("[data-apply-count]").forEach(function (el) {
      var out = root.querySelector('[data-count-for="' + el.getAttribute("name") + '"]');
      if (!out) return;
      var update = function () {
        /* read at count time, so a cap that lands from the wire after this is wired still shows */
        var max = parseInt(el.getAttribute("maxlength"), 10);
        if (!max) return;
        var n = (el.value || "").length;
        if (n >= max) {
          out.textContent = "You have reached the " + max + "-character limit — anything past this is not sent. Please shorten it or email us the rest.";
          out.className = "lfy-apply__count is-full";
          out.hidden = false;
        } else if (n > max * 0.8) {
          out.textContent = (max - n) + " characters left";
          out.className = "lfy-apply__count";
          out.hidden = false;
        } else {
          out.hidden = true;
        }
      };
      el.addEventListener("input", update);
      el.addEventListener("paste", function () { setTimeout(update, 0); });
      updaters.push(update);
      update();
    });
  }
  wireCounters();

  /* ── The caps come from the server now ──────────────────────────────────────────────────────
   * These numbers were mine: I read them off refusals and wrote them into the markup. That works
   * right up until the server moves one, and then the failure is silent in whichever direction it
   * moved — a raised limit means maxlength clips a paste the server would have accepted, a lowered
   * one means the applicant fills a box whose contents get refused on submit.
   *
   * GET /apps/cipzo/trade publishes them as applicationLimits, and — checked, not assumed — it
   * publishes them to a SIGNED-OUT visitor too, which is the only reason this is usable here: an
   * applicant is by definition not yet an approved trade customer.
   *
   *   {"signedIn":false,"identityShape":"empty","applicationLimits":{"tradeTypeMaxChars":120,"messageMaxChars":2000}}
   *
   * The markup keeps the same numbers as its fallback, so the form is fully usable before this
   * lands and still usable if it never does. Anything that is not a positive whole number is
   * ignored rather than trusted — a cap of 0 or null would empty the field on every keystroke. */
  var LIMIT_FIELDS = { tradeTypeMaxChars: "tradeType", messageMaxChars: "message" };
  function applyServerLimits(limits) {
    if (!limits || typeof limits !== "object") return [];
    var moved = [];
    Object.keys(LIMIT_FIELDS).forEach(function (key) {
      var name = LIMIT_FIELDS[key];
      var n = limits[key];
      if (typeof n !== "number" || !isFinite(n) || n < 1 || Math.floor(n) !== n) return;
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) return;
      var was = parseInt(el.getAttribute("maxlength"), 10);
      if (was === n) return;
      el.setAttribute("maxlength", String(n));
      CAPS[name] = n;
      moved.push(name + " " + was + " -> " + n);
    });
    return moved;
  }

  var base = String(root.getAttribute("data-endpoint") || "").replace(/\/apply$/, "");
  if (base) {
    fetch(base, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var moved = applyServerLimits(d && d.applicationLimits);
        /* Only worth saying when the server disagrees with the markup — that is the desync. */
        if (moved.length && window.console) console.info("[lfy-apply] limits from the server: " + moved.join(", "));
        updaters.forEach(function (u) { u(); });
      })
      .catch(function () { /* the markup's caps stand; the form still works */ });
  }
  window.LFY_APPLY = { applyServerLimits: applyServerLimits, caps: function () { return CAPS; } };

  /* ── VALIDATION THE APPLICANT CAN SEE ───────────────────────────────────────────────────────
   * Every field is checked on submit, not one at a time — a trader should not fix one field only
   * to be told about the next. Each problem is shown ON its field: a red border, a sentence
   * directly under it, aria-invalid for screen readers, and the first one is focused and scrolled
   * into view. Typing into a field clears its error.
   *
   * ⛔ ALL SIX CONTACT AND BUSINESS FIELDS ARE REQUIRED (founder, 2026-09-10: "match Klaviyo
   *    exactly"). Phone and ABN are also FORMAT-checked: the phone field once took "call me
   *    maybe", and an ABN is always 11 digits, so a typo is caught here rather than on an invoice
   *    (D14: recorded, never verified against the register — a format check is not verification).
   * ⚠ STILL CONVENIENCE, NOT ENFORCEMENT: the server accepts a submission without contact details.
   *   Routed to the app lane. A direct POST bypasses everything here. */
  /* In the ORDER THE FORM SHOWS THEM, so the first problem focused is the topmost one. They were
   * out of order once — ABN is second on the form and was checked last — and with several errors
   * the cursor skipped past it. `missing` is what an empty required field says; `msg` is what a
   * filled-but-wrong one says. "Use digits only" is the wrong sentence for a blank phone. */
  var RULES = [
    { name: "companyName", required: true, msg: "Enter your business name." },
    { name: "abn", required: true, missing: "Enter your ABN.", msg: "An ABN is 11 digits \u2014 please check it.",
      test: function (v) { return /^[0-9 ]+$/.test(v) && v.replace(/\D/g, "").length === 11; } },
    { name: "tradeType", required: true, msg: "Choose or type your trade." },
    { name: "contactName", required: true, msg: "Enter your name so we know who to contact." },
    { name: "contactEmail", required: true, missing: "Enter an email address we can reach you on.",
      msg: "That doesn't look like an email address \u2014 please check it.",
      test: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); } },
    { name: "contactPhone", required: true, missing: "Enter a phone number we can call you on.",
      msg: "Use digits only for the phone number \u2014 for example 0412 345 678.",
      test: function (v) { return /^[0-9 +()\-]+$/.test(v) && v.replace(/\D/g, "").length >= 8; } },
  ];
  function fieldOf(el) { return el.closest ? el.closest(".lfy-apply__field") : null; }
  function setError(el, msg) {
    var f = fieldOf(el);
    if (!f) return;
    var id = "lfy-apply-err-" + el.name;
    var e = f.querySelector(".lfy-apply__error");
    if (msg) {
      if (!e) { e = document.createElement("span"); e.className = "lfy-apply__error"; e.id = id; f.appendChild(e); }
      e.textContent = msg;
      f.classList.add("is-invalid");
      el.setAttribute("aria-invalid", "true");
      el.setAttribute("aria-describedby", id);
    } else {
      if (e) e.remove();
      f.classList.remove("is-invalid");
      el.removeAttribute("aria-invalid");
      el.removeAttribute("aria-describedby");
    }
  }
  function validate() {
    var first = null, n = 0;
    RULES.forEach(function (r) {
      var el = form.querySelector('[name="' + r.name + '"]');
      if (!el) return;
      var v = String(el.value || "").trim();
      var bad = (r.required && !v) || (!!v && !!r.test && !r.test(v));
      setError(el, bad ? ((r.required && !v && r.missing) || r.msg) : "");
      if (bad) { n++; if (!first) first = el; }
    });
    if (!first) return true;
    say(n === 1 ? "Please fix the highlighted field." : "Please fix the " + n + " highlighted fields.", "warn");
    first.focus();
    if (first.scrollIntoView) first.scrollIntoView({ block: "center", behavior: "smooth" });
    return false;
  }
  form.addEventListener("input", function (e) {
    var el = e.target;
    if (!el || !el.name) return;
    var f = fieldOf(el);
    if (f && f.classList.contains("is-invalid")) setError(el, "");
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (submitBtn.disabled) return;

    var body = collect();
    if (!validate()) return;

    submitBtn.disabled = true;
    var original = submitBtn.textContent;
    submitBtn.textContent = "Sending…";
    say("", "");

    fetch(root.getAttribute("data-endpoint"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    })
      .then(function (res) {
        // A gate denial carries no body by design, so never assume one is parseable.
        return res.text().then(function (t) {
          var data = null;
          try { data = JSON.parse(t); } catch (err) {}
          return { status: res.status, data: data || {} };
        });
      })
      .then(function (r) {
        submitBtn.disabled = false;
        submitBtn.textContent = original;
        var ok = (r.status === 200 || r.status === 201) && r.data.ok !== false;
        var m = messageFor(r.status, r.data.reason);
        if (ok) {
          /* ⛔ The application id is a raw UUID and is deliberately not shown. A prospect cannot use
           * it, cannot quote it to anyone, and showing one in place of a human promise makes the
           * confirmation look like a receipt for something that has not happened yet. */
          form.hidden = true;
          if (doneEl) doneEl.hidden = false;
          say("", "");
          if (doneEl && doneEl.scrollIntoView) doneEl.scrollIntoView({ block: "center", behavior: "smooth" });
          return;
        }
        say(m.text, m.tone);
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = original;
        /* ⛔ A TRANSPORT FAILURE IS NOT A REFUSAL, and for this form it is the most dangerous state:
         * the applicant has typed everything and has no idea whether it arrived. Their details stay
         * in the fields and they are given a route that cannot fail. */
        say("We couldn't send that — your details are still here. Please try again, or email ashfield@lightsforyou.com.au.", "err");
      });
  });
})();
